import { ArrowRight, CreditCard, Fuel } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBodyClass } from "@/lib/useBodyClass";

export const MobileCheckoutBar = ({ step, itemsCount, total, quote, onContinue, paying, payDisabled }) => {
  useBodyClass("has-checkout-bar");
  return (
    <div
      data-testid="mobile-checkout-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(15,23,42,0.18)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="px-4 h-[76px] flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs text-slate-500 truncate flex items-center gap-1">
            {itemsCount === 0 ? "Sin servicios" : `${itemsCount} servicio${itemsCount > 1 ? "s" : ""}`}
            {quote?.fee > 0 && <span className="inline-flex items-center gap-0.5 text-cyan-700"><Fuel className="h-3 w-3" /> +{quote.fee.toFixed(2)} €</span>}
          </p>
          <p className="font-heading font-bold text-xl text-slate-900 leading-tight" data-testid="mobile-checkout-total">{total.toFixed(2)} €</p>
        </div>
        {step === 1 ? (
          <Button key="continue" onClick={onContinue} data-testid="mobile-continue-btn" className="h-12 rounded-full px-6 bg-cyan-500 hover:bg-cyan-600 text-base shrink-0">
            Continuar <ArrowRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button key="pay" type="submit" form="booking-details-form" disabled={paying || payDisabled} data-testid="mobile-pay-btn"
            className="h-12 rounded-full px-6 bg-cyan-500 hover:bg-cyan-600 text-base shrink-0">
            <CreditCard className="h-4 w-4" /> {paying ? "Redirigiendo..." : "Pagar con tarjeta"}
          </Button>
        )}
      </div>
    </div>
  );
};
